import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS, QUERY_KEYS } from '~shared/api/query-keys';

export interface UpdateClassChargeParams {
  studentId: string;
  type: 'pause' | 'resume';
  entityType: 'enrollment';
  entityId: Array<string>;
}

export const updateClassCharge = async ({
  studentId,
  type,
  ...params
}: UpdateClassChargeParams) => {
  const response = await baseAPI.put<unknown>(
    `/subscription/${type}/${studentId}`,
    params,
  );
  return response.data;
};

export const useUpdateClassChargeMutation = () => {
  return useMutation({
    mutationFn: (params: UpdateClassChargeParams) => updateClassCharge(params),
    onSuccess: (_, y) => {
      const studentId = y.studentId;
      // const type = y.type;
      void queryClient.invalidateQueries({
        predicate: (query) => {
          return (
            (query.queryKey[0] === KEYS.ACTIVE_TUITION_DETAILS ||
              query.queryKey[0] === KEYS.PAUSED_TUITION_DETAILS ||
              query.queryKey[0] === KEYS.STUDENT_CLASS_HISTORY) &&
            query.queryKey[1] === studentId
          );
        },
        // queryKey: [
        //   type === 'pause'
        //     ? KEYS.ACTIVE_TUITION_DETAILS
        //     : KEYS.PAUSED_TUITION_DETAILS,
        //   studentId,
        // ],
      });
      void queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.STUDENT(studentId),
      });
    },
  });
};
